import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_2 = { class: "tw-w-full tw-grid tw-items-center" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ContractSignYellowIcon from "@/core/components/icons/ContractSignYellowIcon.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentFailureModal',
  emits: ["on-close", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const onCloseModal = () => {
  emits("on-close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "tw-max-w-[450px]",
    onOnClose: onCloseModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ContractSignYellowIcon),
        _createVNode(Text, {
          variant: "h4",
          textAlign: "center",
          lineHeight: "28px"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Payment Unsuccessful")
          ]),
          _: 1
        }),
        _createVNode(Text, { textAlign: "center" }, {
          default: _withCtx(() => [
            _createTextVNode("Something went wrong. Please try again")
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          disabled: _ctx.loading,
          label: "Try Again",
          onClick: onCloseModal
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})